var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5.5H9.5C10.6046 5.5 11.5 6.39543 11.5 7.5V16.5C11.5 17.0523 11.0523 17.5 10.5 17.5H4.5C3.94772 17.5 3.5 17.0523 3.5 16.5V6.5C3.5 5.94772 3.94772 5.5 4.5 5.5ZM14.5 19.5C14.1494 19.5 13.8128 19.4398 13.5 19.3293V19.5C13.5 20.0523 13.0523 20.5 12.5 20.5C11.9477 20.5 11.5 20.0523 11.5 19.5V19.3293C11.1872 19.4398 10.8506 19.5 10.5 19.5H4.5C2.84315 19.5 1.5 18.1569 1.5 16.5V6.5C1.5 4.84315 2.84315 3.5 4.5 3.5H9.5C10.6947 3.5 11.7671 4.02376 12.5 4.85418C13.2329 4.02376 14.3053 3.5 15.5 3.5H20.5C22.1569 3.5 23.5 4.84315 23.5 6.5V16.5C23.5 18.1569 22.1569 19.5 20.5 19.5H14.5ZM13.5 7.5V16.5C13.5 17.0523 13.9477 17.5 14.5 17.5H20.5C21.0523 17.5 21.5 17.0523 21.5 16.5V6.5C21.5 5.94772 21.0523 5.5 20.5 5.5H15.5C14.3954 5.5 13.5 6.39543 13.5 7.5ZM5.5 7.5H9.5V9.5H5.5V7.5ZM15.5 7.5H19.5V9.5H15.5V7.5ZM19.5 10.5H15.5V12.5H19.5V10.5ZM5.5 10.5H9.5V12.5H5.5V10.5ZM19.5 13.5H15.5V15.5H19.5V13.5ZM5.5 13.5H9.5V15.5H5.5V13.5Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicable);
export default __webpack_public_path__ + "static/media/applicable.9163ecc98797bc94c6bd5edd30632417.svg";
export { ForwardRef as ReactComponent };